import { PageId } from 'constants/pages'
import type { TStep } from 'src/types'

export const STEPS_INTL_MW: TStep[] = [
  {
    pageId: PageId.ANALYZING_INTL_MW,
  },
  {
    pageId: PageId.START_INTL_MW,
  },
  {
    pageId: PageId.LIVING_UP_POTENTIAL_INTL_MW,
  },
  {
    pageId: PageId.STRUGGLE_MOST_INTL_MW,
  },
  {
    pageId: PageId.STUCK_AREAS_INTL_MW,
  },
  {
    pageId: PageId.REASON_TO_START_INTL_MW,
  },
  {
    pageId: PageId.GOOD_COMPANY_INTL_MW,
  },
  {
    pageId: PageId.LITTLE_INTEREST_INTL_MW,
  },
  {
    pageId: PageId.EMOTION_SHIFTS_INTL_MW,
  },
  {
    pageId: PageId.CALM_DOWN_INTL_MW,
  },
  {
    pageId: PageId.RECHARGING_INTL_MW,
  },
  {
    pageId: PageId.ACCEPT_COMPLIMENTS_INTL_MW,
  },
  {
    pageId: PageId.PRIORITIZE_OTHERS_INTL_MW,
  },
  {
    pageId: PageId.LEAN_ON_SOMEONE_INTL_MW,
  },
  {
    pageId: PageId.UNDERSTOOD_BY_OTHERS_INTL_MW,
  },
  {
    pageId: PageId.WE_FEEL_YOU_INTL_MW,
  },
  {
    pageId: PageId.OVERTHINKING_DECISIONS_INTL_MW,
  },
  {
    pageId: PageId.AUTOPILOT_INTL_MW,
  },
  {
    pageId: PageId.UNABLE_TO_START_INTL_MW,
  },
  {
    pageId: PageId.DISTRACTIONS_INTL_MW,
  },
  {
    pageId: PageId.MEANING_TO_DO_INTL_MW,
  },
  {
    pageId: PageId.OTHER_SIDE_INTL_MW,
  },
  {
    pageId: PageId.GENUINE_STRENGTHS_INTL_MW,
  },
  {
    pageId: PageId.TIME_INVESTMENT_INTL_MW,
  },
  {
    pageId: PageId.HEAR_ABOUT_US_INTL_MW,
  },
  {
    pageId: PageId.PREPARE_FLOW_INTL_MW,
  },
  {
    pageId: PageId.PATTERNS_IMPACT_INTL_MW,
  },
  {
    pageId: PageId.EMAIL_INTL_MW,
  },
  {
    pageId: PageId.OFFER_INTL_MW,
  },
  {
    pageId: PageId.SPECIAL_DISCOUNT_INTL_MW,
  },
  {
    pageId: PageId.CANCEL_OFFER_INTL_MW,
  },
  {
    pageId: PageId.PAYMENT_INTL_MW,
  },
  {
    pageId: PageId.REGISTRATION_INTL_MW,
  },
  {
    pageId: PageId.NAME_ENTRY_INTL_MW,
  },
  {
    pageId: PageId.REPORT_INTL_MW,
  },
]
